import { useForm, useFormState } from "react-final-form";
import { useEffect, useMemo } from "react";

import RffInputWrapper from "../shared/RffInputWrapper";
import SelectFileAssignmentInput from "../../inputs/SelectFileAssignmentInput";

const RffSelectDocGroupTypeField = ({
  name,
  label,
  options,
  required = false,
  row = false,
  disabled,
  suppressGrid,
  size,
  helperText,
  sx,
}) => {
  const {
    values: { docGroup, docType },
    submitFailed,
  } = useFormState();

  const { change } = useForm();

  const onDocGroupChange = (dg, dt) => {
    change("docGroup", dg);
    change("docType", dt);
  };

  useEffect(() => {
    return () => {
      change("docGroup", undefined);
      change("docType", undefined);
    };
  }, [change]);

  // ✅ validation logic
  const hasError = useMemo(() => {
    if (!required) return false;
    return submitFailed && (!docGroup || !docType);
  }, [required, submitFailed, docGroup, docType]);

  const resolvedHelperText = useMemo(() => {
    if (hasError) return "Document group and type are required";

    return helperText;
  }, [hasError, helperText, row]);

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      helperText={resolvedHelperText}
      row={row}
    >
      <SelectFileAssignmentInput
        onlyDisplayDocType
        placeholder="Search document categories..."
        onChange={(params) => {
          onDocGroupChange(params?.docGroup, params?.docType);
        }}
        docGroup={docGroup}
        docType={docType}
        sx={sx}
        error={hasError}
        // helperText={resolvedHelperText}
        disabled={disabled}
      />
    </RffInputWrapper>
  );
};

export default RffSelectDocGroupTypeField;
